import { theme } from "../theme";

export const DashboardStyles = (props) => ({
  dashCtn: {
    color: theme.palette.primary.black,
    padding: '0 48px',
    [theme.breakpoints.down('md')]: {
      padding: '0px',
    },
  },
  employerLink: {
    paddingLeft: '25px',
    textDecoration: 'none',
    fontSize: '1.2rem',
    color: theme.palette.secondary.black,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: '12px',
    },
  },
  upperCtn: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '64px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '16px',
      padding: '0px 16px',
    },
  },
  buttonCtn: {
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px',
    },
  },
  formControl: {
    minWidth: 200,
    fontSize: '10px',
  },
  statusSelect: {
    height: '50px',
    width: '100%',
    textAlign: 'center',
    color: theme.palette.secondary.black,
    fontSize: '1.2rem',
    border: 'none',
    backgroundColor: theme.palette.primary.white,
    '& .MuiOutlinedInput-input': {
      textTransform: 'capitalize',
    },
    '& 	.MuiSelect-icon': {
      color: theme.palette.secondary.black,
    },
    '& 	.MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.primary.black}`,
    },
    [theme.breakpoints.down('md')]: {
      height: '40px',
      fontSize: '14px',
    },
  },
  statusSelectSecondary:{
    textAlign: 'flex-start',
    '& 	.MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.secondary.mediumGray}`
    },
  },
  tableGrid: {
    minHeight: 965,
    borderRadius: '4px',
    fontSize: '1rem',
    '& .MuiDataGrid-columnSeparator': {                                                  
      display: 'none',
    },
    '& .MuiDataGrid-columnHeadersInner': {
      fontSize: '1.3rem',
      [theme.breakpoints.down('md')]: {
        fontSize: '1.1rem',
      },
      '& .MuiDataGrid-columnHeader': {
        padding: '0',
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: '700',
        paddingLeft: '32px',
        color: theme.palette.primary.black,
      },
    },
    '& .MuiDataGrid-row': {
      fontSize: '1.2rem',
      color: theme.palette.secondary.black,
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
      },
    },
    '& .MuiDataGrid-cell': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: '30px',
    },
    '& .MuiDataGrid-virtualScroller': {
      '::-webkit-scrollbar': {
        width: '10px',
      },
      '::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '::-webkit-scrollbar-thumb': {
        background: 'rgba(16, 16, 16, 0.5)',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    },
    '& 	.MuiDataGrid-checkboxInput': {
      '& .MuiSvgIcon-root': {
        fontSize: '24px',
        [theme.breakpoints.down('md')]: {
          fontSize: '16px',
        },
      },
    },
  },
  stateConfig:{
    textDecoration: 'none',
    '& .MuiButton-root': {
      paddingX: '28px',
      width: '100%',
      height: '50px',
      fontSize: '1.25rem',
      color: theme.palette.primary.black,
      background: 'none',
      boxShadow: 'none',
      border: `1px solid ${theme.palette.primary.black}`,
      textTransform: 'none',
      letterSpacing: '0',
      '&:hover': {
        background: 'inherit',
        boxShadow: 6,
      },
    },
  },
  buttonTools: {
    borderRadius: '4px',
    boxShadow: 'none',
    color: theme.palette.secondary.black,
    justifyContent: 'center',
    '& .MuiButtonGroup-grouped': {
      color: theme.palette.secondary.black,
      height: '50px',
      padding: '0',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      '& .MuiSvgIcon-root': {
        fontSize: '2rem',
      },
      '&::after': {
        position: 'absolute',
        content: '""',
        height: '2px',
        borderRadius: '24px',
        bottom: '12px',
        left: 'calc(50% - 4px)',
        right: '0',
        width: '14px',
        background: theme.palette.secondary.black,
      },
      [theme.breakpoints.down('md')]: {
        height: '40px',
        '& .MuiSvgIcon-root': {
          fontSize: '1.2rem',
        },
      },
    },
    wrapperTable: {
      minHeight: 965,
      width: '100%',
      backgroundColor: theme.palette.primary.white,
    },
  },
  autocompleteField: {
    width: '100%',
    display: 'flex',
    '& .MuiAutocomplete-input': {
        height: '18px',
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiAutocomplete-input': {
        height: '13px',
      },
    },
  },
  containerIsMonday:{
    width: '100%',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    background: theme.cards.bgCards,
    color: theme.palette.primary.black,
    gap: '15px',
    margin: '0px',
  },
  containerBulkTemplate:{
    width: '100%',
    minHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 50px 50px',
  },
  titleBulk:{
    fontSize: { xs: "16px", md: "20px" },
    margin: '0px',
    fontWeight: '400',
    lineHeight: { xs: "18px", md: "26px" },
  },
  toggleContainer: {
    marginBottom: '10px',
    [theme.breakpoints.down('md')]: {
      padding: '15px',
    },
  },
  toggleContainerButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  toggleContainerText: {
    fontSize: '12px',
    fontWeight: '500',
    color: theme.palette.secondary.mainGray,
  },
  selectBulkTemplate: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.primary.black}`,
  },
  '& .MuiSelect-select': {
      color: theme.palette.secondary.black,
  },
  '& .MuiSelect-icon': {
      color: theme.palette.secondary.black,
  },
  },
});
